// extracted by mini-css-extract-plugin
module.exports = {"starContainer":"x1n74D"};